import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import "./i18n";
import { ConfigProvider } from "antd";
import { EmptyDataLabel } from "components/empty-data-label";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <ConfigProvider
    renderEmpty={() => <EmptyDataLabel />}
    theme={{
      token: {
        colorPrimary: "#CD2A3F", // 🔴 your main red
        colorPrimaryHover: "#ff7875", // 🔴 light red for hover
        colorPrimaryActive: "#CD2A3F", // 🔴 darker red for active
      },
    }}
  >
    <App />
  </ConfigProvider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
